import $ from 'jquery';
import {onLayoutChange} from './layout';


class Marquee {
    constructor(ele: HTMLElement) {
        const $ele = $(ele);
        $ele.addClass('effect-marquee');
        const span1 = document.createElement('span');
        span1.append(...Array.from(ele.childNodes));
        span1.prepend(document.createElement('strong'));
        const span2 = span1.cloneNode(true);
        // el.append(span1, span2);
        const marqueeWrapperSpan = document.createElement('span');
        marqueeWrapperSpan.append(span1, span2);

        const marqueeWrapperSpan2 = marqueeWrapperSpan.cloneNode(true);
        // NOTE: weiterer wrapper span wird für zusätzlichen emerge Effekt benötigt:
        const emergeWrapperSpan = document.createElement('span');
        emergeWrapperSpan.append(marqueeWrapperSpan, marqueeWrapperSpan2);
        ele.append(emergeWrapperSpan);
        onLayoutChange(() => {
            const animationDurationFactor = marqueeWrapperSpan.offsetWidth / window.innerWidth;
            emergeWrapperSpan.style.setProperty('--animationDurationFactor', animationDurationFactor as unknown as string);
        });
        // $eles.addClass('emerge');
        // $eles.each((index, ele) => {
        //     const text = $(ele).html();
        //     $(ele).empty();
        //     const $words = text.split(' ').map(w =>
        //         $('<span>').append($('<span>').html(w)).appendTo(ele)
        //     );
        // });
        // NOTE: nur wenn emerge effekt automatisch laufen soll, sobald element sichtbar:
        // $(window).on('scroll', () => {
        //     const innerHeight = window.innerHeight;
        //     $eles.each((index, ele) => {
        //         const bbox = ele.getBoundingClientRect();
        //         if(bbox.top < innerHeight)
        //             ele.classList.add('emerge-show');
        //         else
        //             ele.classList.remove('emerge-show');
        //     });
        // });
    }
}

export default Marquee;

function createMarquee(el: HTMLElement) {
    const span1 = document.createElement('span');
    span1.append(...Array.from(el.childNodes));
    span1.prepend(document.createElement('strong'));
    const span2 = span1.cloneNode(true);
    // el.append(span1, span2);
    const marqueeWrapperSpan = document.createElement('span');
    marqueeWrapperSpan.append(span1, span2);

    const marqueeWrapperSpan2 = marqueeWrapperSpan.cloneNode(true);
    // NOTE: weiterer wrapper span wird für emerge Effekt benötigt:
    const emergeWrapperSpan = document.createElement('span');
    emergeWrapperSpan.append(marqueeWrapperSpan, marqueeWrapperSpan2);
    el.append(emergeWrapperSpan);
    onLayoutChange(() => {
        const animationDurationFactor = marqueeWrapperSpan.offsetWidth / window.innerWidth;
        emergeWrapperSpan.style.setProperty('--animationDurationFactor', animationDurationFactor as unknown as string);
    });
}
